import { Label } from "../model/Label.js";
import { Table } from "./Table.js";

export class ListItem {
    public element: HTMLDivElement;

    constructor(public readonly data: VOImmo) {
        this.element = document.createElement("div");
        this.element.className = "e5-list-item";
        this.element.setAttribute("data-immoid", data.id + "");

        var table = new Table();
        if (data.size) {
            table.label("immo.size", data.size);
        }
        if (data.type_of_use && data.type_of_use.length > 0) {
            table.label("immo.type_of_use", data.type_of_use.join(", ").toUpperCase());
        }
        if (data.situation) {
            table.label("immo.situation", data.situation);
        }
        if (data.available_area) {
            table.label("immo.available_area", data.available_area);
        }
        if (data.priority_trade) {
            table.label("immo.priority_trade", data.priority_trade);
        }
        if (data.availability) {
            table.label("immo.availability", data.availability);
        }

        this.element.innerHTML = `
        <div class="e5-list-item__header">
            ${data.title ? `<h2 class="e5-list-item__title">${e5.Text.escapeHtml(data.title)}</h2>` : ""}
            ${data.address ? `<div class="e5-list-item__address">${e5.Text.escapeHtml(data.address)}</div>` : ""}
        </div>
        <div class="e5-list-item__body row">
            <div class="col-md-6">
            ${data.featured_image ? `<img class="e5-list-item__image" src="${data.featured_image.sizes.large}" />` : ""}
            </div>
            <div class="col-md-6">
                ${table.toString()}
                <a class="e5-base__button e5-base__no-print" href="${data.permalink}">
                    <span class="e5-base__button-label">${Label.html("map.goto_report")}</span>
                    <span class="e5-base__button-icon fas fa-arrow-circle-right"></span>
                </a>
                <br class="e5-list-item__button-separator">
                <button class="e5-base__button e5-base__no-print" data-showonmap="${data.id}" type="button">
                    <span class="e5-base__button-label">${Label.html("map.show_on_map")}</span>
                    <span class="e5-base__button-icon fas fa-arrow-circle-right"></span>
                </button>
            </div>
        </div>
        `;
    }
}